import { inject,Injectable } from '@angular/core';
import { CredentialsCookiesService, SessionCookieService } from '@docpath/linces-angular-components/common';
import { Constants } from 'src/app/constants/constants';

import { AppSession } from '../models/app-session.model';

@Injectable({
    providedIn: 'root'
})
export class CloudService {

    private readonly sessionCookieService = inject(SessionCookieService);
    private readonly credentialsCookiesService = inject(CredentialsCookiesService);

    isModeCloud(): boolean {
        return this.sessionCookieService.getSessionCookie() !== null
            && this.sessionCookieService.getSessionCookie()?.app !== undefined
            && (this.sessionCookieService.getSessionCookie()?.app as AppSession).mode === Constants.APP_MODE_CLOUD;
    }

    updateCookies() {

        const user = this.sessionCookieService.getSessionCookie()?.user;

        const access_token = user?.credentials.access_token;
        const refresh_token = user?.credentials.refresh_token;
        const expires_in = Number(user?.credentials.expires_in);

        if (access_token && refresh_token && expires_in
            && (access_token !== this.credentialsCookiesService.getAccessCookie()
                || refresh_token !== this.credentialsCookiesService.getRefreshCookie())) {
            this.credentialsCookiesService.store({ access_token, refresh_token, expires_in });
        }

    }

    getAccessTokenCookie(): string {
        return this.credentialsCookiesService.getAccessCookie();
    }

    getRefreshTokenCookie(): string {
        return this.credentialsCookiesService.getRefreshCookie();
    }

}